module.exports = __webpack_public_path__ + "static/media/last.4dda9550.png";